<div class="fixed inset-0 flex items-center justify-center">
  <p class="mt-4 text-3xl font-bold">Website is under maintenance</p>
</div>
